import { createAction, props } from '@ngrx/store';
import {
  CompanyProfileSkeleton,
  PagedAircraftTypeRatingAudit,
  PagedBusinessCategoryAudit,
  PagedCompanyAddressAudit,
  PagedCompanyProfileAudit,
  PagedCrewMemberTypeAudit,
  PagedCustomerDutyAudit,
  PagedDelayTypeAudit,
  PagedDepartmentAudit,
  PagedDutyTimeBufferAudit,
  PagedExpenseTypeAudit,
  PagedJobGradeAudit,
  PagedPaymentTypeAudit,
  PagedStaffEventTypeAudit,
  PagedStaffGroupAudit,
  PagedDutyTimeAllowanceAudit
} from '../../+models/company-profile-audit.model';

export enum CompanyProfileActionTypes {
  LoadCompanyAddressAudit = '[SharedAudit CompanyProfile] Load CompanyAddress Audit',
  LoadNextPageCompanyAddressAudit = '[SharedAudit CompanyProfile] Load NextPage CompanyAddress Audit',
  CompanyAddressAuditLoaded = '[SharedAudit CompanyProfile] CompanyAddress Audit Loaded',
  CompanyAddressAuditLoadError = '[SharedAudit CompanyProfile] CompanyAddress Audit Load Error',

  LoadCustomerDutyAudit = '[SharedAudit CompanyProfile] Load CustomerDuty Audit',
  LoadNextPageCustomerDutyAudit = '[SharedAudit CompanyProfile] Load NextPage CustomerDuty Audit',
  CustomerDutyAuditLoaded = '[SharedAudit CompanyProfile] CustomerDuty Audit Loaded',
  CustomerDutyAuditLoadError = '[SharedAudit CompanyProfile] CustomerDuty Audit Load Error',

  LoadDelayTypeAudit = '[SharedAudit CompanyProfile] Load DelayType Audit',
  LoadNextPageDelayTypeAudit = '[SharedAudit CompanyProfile] Load NextPage DelayType Audit',
  DelayTypeAuditLoaded = '[SharedAudit CompanyProfile] DelayType Audit Loaded',
  DelayTypeAuditLoadError = '[SharedAudit CompanyProfile] DelayType Audit Load Error',

  LoadDepartmentAudit = '[SharedAudit CompanyProfile] Load Department Audit',
  LoadNextPageDepartmentAudit = '[SharedAudit CompanyProfile] Load NextPage Department Audit',
  DepartmentAuditLoaded = '[SharedAudit CompanyProfile] Department Audit Loaded',
  DepartmentAuditLoadError = '[SharedAudit CompanyProfile] Department Audit Load Error',

  LoadDutyTimeBufferAudit = '[SharedAudit CompanyProfile] Load DutyTimeBuffer Audit',
  LoadNextPageDutyTimeBufferAudit = '[SharedAudit CompanyProfile] Load NextPage DutyTypeBuffer Audit',
  DutyTimeBufferAuditLoaded = '[SharedAudit CompanyProfile] DutyTimeBuffer Audit Loaded',
  DutyTimeBufferAuditLoadError = '[SharedAudit CompanyProfile] DutyTimeBuffer Audit Load Error',

  LoadExpenseTypeAudit = '[SharedAudit CompanyProfile] Load ExpenseType Audit',
  LoadNextPageExpenseTypeAudit = '[SharedAudit CompanyProfile] Load NextPage ExpenseType Audit',
  ExpenseTypeAuditLoaded = '[SharedAudit CompanyProfile] ExpenseType Audit Loaded',
  ExpenseTypeAuditLoadError = '[SharedAudit CompanyProfile] ExpenseType Audit Load Error',

  LoadCrewMemberTypeAudit = '[SharedAudit CompanyProfile] Load CrewMemberType Audit',
  LoadNextPageCrewMemberTypeAudit = '[SharedAudit CompanyProfile] Load NextPage CrewMemberType Audit',
  CrewMemberTypeAuditLoaded = '[SharedAudit CompanyProfile] CrewMemberType Audit Loaded',
  CrewMemberTypeAuditLoadError = '[SharedAudit CompanyProfile] CrewMemberType Audit Load Error',

  LoadPaymentTypeAudit = '[SharedAudit CompanyProfile] Load PaymentType Audit',
  LoadNextPagePaymentTypeAudit = '[SharedAudit CompanyProfile] Load NextPage PaymentType Audit',
  PaymentTypeAuditLoaded = '[SharedAudit CompanyProfile] PaymentType Audit Loaded',
  PaymentTypeAuditLoadError = '[SharedAudit CompanyProfile] PaymentType Audit Load Error',

  LoadBusinessCategoryAudit = '[SharedAudit CompanyProfile] Load BusinessCategory Audit',
  LoadNextPageBusinessCategoryAudit = '[SharedAudit CompanyProfile] Load NextPage BusinessCategory Audit',
  BusinessCategoryAuditLoaded = '[SharedAudit CompanyProfile] BusinessCategory Audit Loaded',
  BusinessCategoryAuditLoadError = '[SharedAudit CompanyProfile] BusinessCategory Audit Load Error',

  LoadJobGradeAudit = '[SharedAudit CompanyProfile] Load JobGrade Audit',
  LoadNextPageJobGradeAudit = '[SharedAudit CompanyProfile] Load NextPage JobGrade Audit',
  JobGradeAuditLoaded = '[SharedAudit CompanyProfile] JobGrade Audit Loaded',
  JobGradeAuditLoadError = '[SharedAudit CompanyProfile] JobGrade Audit Load Error',

  LoadStaffEventTypeAudit = '[SharedAudit CompanyProfile] Load StaffEventType Audit',
  LoadNextPageStaffEventTypeAudit = '[SharedAudit CompanyProfile] Load NextPage StaffEventType Audit',
  StaffEventTypeAuditLoaded = '[SharedAudit CompanyProfile] StaffEventType Audit Loaded',
  StaffEventTypeAuditLoadError = '[SharedAudit CompanyProfile] StaffEventType Audit Load Error',

  AircraftTypeRatingTypesLoaded = '[SharedAudit CompanyProfile] Aircraft Type Rating Type Loaded',
  AircraftTypeRatingTypesLoadError = '[SharedAudit CompanyProfile] Aircraft Type Rating Type Load Error',

  LoadStaffGroupAudit = '[SharedAudit CompanyProfile] Load StaffGroup Audit',
  LoadNextPageStaffGroupAudit = '[SharedAudit CompanyProfile] Load NextPage StaffGroup Audit',
  StaffGroupAuditLoaded = '[SharedAudit CompanyProfile] StaffGroup Audit Loaded',
  StaffGroupAuditLoadError = '[SharedAudit CompanyProfile] StaffGroup Audit Load Error',

  LoadDutyTimeAllowanceAudit = '[SharedAudit CompanyProfile] Load DutyTimeAllowance Audit',
  LoadNextPageDutyTimeAllowanceAudit = '[SharedAudit CompanyProfile] Load NextPage DutyTypeAllowance Audit',
  DutyTimeAllowanceAuditLoaded = '[SharedAudit CompanyProfile] DutyTimeAllowance Audit Loaded',
  DutyTimeAllowanceAuditLoadError = '[SharedAudit CompanyProfile] DutyTimeAllowance Audit Load Error'
}

export const ResetCompanyProfile = createAction('[SharedAudit CompanyProfile] Reset');

// company profile skeleton
export const LoadCompanyProfileAuditSkeleton = createAction(
  '[SharedAudit CompanyProfile] Load Company Profile Audit Skeleton'
);

export const CompanyProfileAuditSkeletonLoaded = createAction(
  '[SharedAudit CompanyProfile] Company Profile Audit Skeleton Loaded',
  props<{ payload: CompanyProfileSkeleton }>()
);

export const CompanyProfileAuditSkeletonLoadError = createAction(
  '[SharedAudit CompanyProfile] Company Profile Audit Skeleton Load Error',
  props<{ err: any }>()
);

// company profile
export const LoadCompanyProfileAudit = createAction(
  '[SharedAudit CompanyProfile] Load CompanyProfile Audit',
  props<{
    companyProfileId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageCompanyProfileAudit = createAction(
  '[SharedAudit CompanyProfile] Load NextPage CompanyProfile Audit',
  props<{ companyProfileId: number }>()
);

export const CompanyProfileAuditLoaded = createAction(
  '[SharedAudit CompanyProfile] CompanyProfile Audit Loaded',
  props<{ companyProfileId: number; audits: PagedCompanyProfileAudit }>()
);

export const CompanyProfileAuditLoadError = createAction(
  '[SharedAudit CompanyProfile] {} Audit Load Error',
  props<{ err: any }>()
);

// aircraft type rating
export const LoadAircraftTypeRatingAudit = createAction(
  '[SharedAudit CompanyProfile] Load AircraftTypeRating Audit',
  props<{
    aircraftTypeRatingId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageAircraftTypeRatingAudit = createAction(
  '[SharedAudit CompanyProfile] Load NextPage AircraftTypeRating Audit',
  props<{ aircraftTypeRatingId: number }>()
);

export const AircraftTypeRatingAuditLoaded = createAction(
  '[SharedAudit CompanyProfile] AircraftTypeRating Audit Loaded',
  props<{ aircraftTypeRatingId: number; audits: PagedAircraftTypeRatingAudit }>()
);

export const AircraftTypeRatingAuditLoadError = createAction(
  '[SharedAudit CompanyProfile] {} Audit Load Error',
  props<{ err: any }>()
);

// company address
export const LoadCompanyAddressAudit = createAction(
  CompanyProfileActionTypes.LoadCompanyAddressAudit,
  props<{
    companyAddressId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageCompanyAddressAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageCompanyAddressAudit,
  props<{ companyAddressId: number }>()
);

export const CompanyAddressAuditLoadError = createAction(
  CompanyProfileActionTypes.CompanyAddressAuditLoadError,
  props<{ err: any }>()
);

export const CompanyAddressAuditLoaded = createAction(
  CompanyProfileActionTypes.CompanyAddressAuditLoaded,
  props<{ companyAddressId: number; audits: PagedCompanyAddressAudit }>()
);

// customer duty
export const LoadCustomerDutyAudit = createAction(
  CompanyProfileActionTypes.LoadCustomerDutyAudit,
  props<{
    customerDutyId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageCustomerDutyAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageCustomerDutyAudit,
  props<{ customerDutyId: number }>()
);

export const CustomerDutyAuditLoadError = createAction(
  CompanyProfileActionTypes.CustomerDutyAuditLoadError,
  props<{ err: any }>()
);

export const CustomerDutyAuditLoaded = createAction(
  CompanyProfileActionTypes.CustomerDutyAuditLoaded,
  props<{ customerDutyId: number; audits: PagedCustomerDutyAudit }>()
);

// delay type
export const LoadDelayTypeAudit = createAction(
  CompanyProfileActionTypes.LoadDelayTypeAudit,
  props<{
    delayTypeId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageDelayTypeAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageDelayTypeAudit,
  props<{ delayTypeId: number }>()
);

export const DelayTypeAuditLoadError = createAction(
  CompanyProfileActionTypes.DelayTypeAuditLoadError,
  props<{ err: any }>()
);

export const DelayTypeAuditLoaded = createAction(
  CompanyProfileActionTypes.DelayTypeAuditLoaded,
  props<{ delayTypeId: number; audits: PagedDelayTypeAudit }>()
);

// department
export const LoadDepartmentAudit = createAction(
  CompanyProfileActionTypes.LoadDepartmentAudit,
  props<{
    departmentId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageDepartmentAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageDepartmentAudit,
  props<{ departmentId: number }>()
);

export const DepartmentAuditLoadError = createAction(
  CompanyProfileActionTypes.DepartmentAuditLoadError,
  props<{ err: any }>()
);

export const DepartmentAuditLoaded = createAction(
  CompanyProfileActionTypes.DepartmentAuditLoaded,
  props<{ departmentId: number; audits: PagedDepartmentAudit }>()
);

// duty time buffer
export const LoadDutyTimeBufferAudit = createAction(
  CompanyProfileActionTypes.LoadDutyTimeBufferAudit,
  props<{
    dutyTimeBufferId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageDutyTimeBufferAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageDutyTimeBufferAudit,
  props<{ dutyTimeBufferId: number }>()
);

export const DutyTimeBufferAuditLoadError = createAction(
  CompanyProfileActionTypes.DutyTimeBufferAuditLoadError,
  props<{ err: any }>()
);

export const DutyTimeBufferAuditLoaded = createAction(
  CompanyProfileActionTypes.DutyTimeBufferAuditLoaded,
  props<{ dutyTimeBufferId: number; audits: PagedDutyTimeBufferAudit }>()
);

// expense type
export const LoadExpenseTypeAudit = createAction(
  CompanyProfileActionTypes.LoadExpenseTypeAudit,
  props<{
    expenseTypeId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageExpenseTypeAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageExpenseTypeAudit,
  props<{ expenseTypeId: number }>()
);

export const ExpenseTypeAuditLoadError = createAction(
  CompanyProfileActionTypes.ExpenseTypeAuditLoadError,
  props<{ err: any }>()
);

export const ExpenseTypeAuditLoaded = createAction(
  CompanyProfileActionTypes.ExpenseTypeAuditLoaded,
  props<{ expenseTypeId: number; audits: PagedExpenseTypeAudit }>()
);

// crew member type
export const LoadCrewMemberTypeAudit = createAction(
  CompanyProfileActionTypes.LoadCrewMemberTypeAudit,
  props<{
    crewMemberTypeId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageCrewMemberTypeAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageCrewMemberTypeAudit,
  props<{ crewMemberTypeId: number }>()
);

export const CrewMemberTypeAuditLoadError = createAction(
  CompanyProfileActionTypes.CrewMemberTypeAuditLoadError,
  props<{ err: any }>()
);

export const CrewMemberTypeAuditLoaded = createAction(
  CompanyProfileActionTypes.CrewMemberTypeAuditLoaded,
  props<{ crewMemberTypeId: number; audits: PagedCrewMemberTypeAudit }>()
);

// payment type
export const LoadPaymentTypeAudit = createAction(
  CompanyProfileActionTypes.LoadPaymentTypeAudit,

  props<{
    paymentTypeId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPagePaymentTypeAudit = createAction(
  CompanyProfileActionTypes.LoadNextPagePaymentTypeAudit,
  props<{ paymentTypeId: number }>()
);

export const PaymentTypeAuditLoadError = createAction(
  CompanyProfileActionTypes.PaymentTypeAuditLoadError,
  props<{ err: any }>()
);

export const PaymentTypeAuditLoaded = createAction(
  CompanyProfileActionTypes.PaymentTypeAuditLoaded,
  props<{ paymentTypeId: number; audits: PagedPaymentTypeAudit }>()
);

// business category
export const LoadBusinessCategoryAudit = createAction(
  CompanyProfileActionTypes.LoadBusinessCategoryAudit,
  props<{
    businessCategoryId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageBusinessCategoryAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageBusinessCategoryAudit,
  props<{ businessCategoryId: number }>()
);

export const BusinessCategoryAuditLoadError = createAction(
  CompanyProfileActionTypes.BusinessCategoryAuditLoadError,
  props<{ err: any }>()
);

export const BusinessCategoryAuditLoaded = createAction(
  CompanyProfileActionTypes.BusinessCategoryAuditLoaded,
  props<{ businessCategoryId: number; audits: PagedBusinessCategoryAudit }>()
);

// job grade
export const LoadJobGradeAudit = createAction(
  CompanyProfileActionTypes.LoadJobGradeAudit,
  props<{ jobGradeId: number; pageNumber: number | null; lastAuditLogId: number | null }>()
);

export const LoadNextPageJobGradeAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageJobGradeAudit,
  props<{ jobGradeId: number }>()
);

export const JobGradeAuditLoadError = createAction(
  CompanyProfileActionTypes.JobGradeAuditLoadError,
  props<{ err: any }>()
);

export const JobGradeAuditLoaded = createAction(
  CompanyProfileActionTypes.JobGradeAuditLoaded,
  props<{ jobGradeId: number; audits: PagedJobGradeAudit }>()
);

// staff event type
export const LoadStaffEventTypeAudit = createAction(
  CompanyProfileActionTypes.LoadStaffEventTypeAudit,
  props<{
    staffEventTypeId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageStaffEventTypeAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageStaffEventTypeAudit,
  props<{ staffEventTypeId: number }>()
);

export const StaffEventTypeAuditLoadError = createAction(
  CompanyProfileActionTypes.StaffEventTypeAuditLoadError,
  props<{ err: any }>()
);

export const StaffEventTypeAuditLoaded = createAction(
  CompanyProfileActionTypes.StaffEventTypeAuditLoaded,
  props<{ staffEventTypeId: number; audits: PagedStaffEventTypeAudit }>()
);

// staff group
export const LoadStaffGroupAudit = createAction(
  CompanyProfileActionTypes.LoadStaffGroupAudit,
  props<{
    staffGroupId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageStaffGroupAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageStaffGroupAudit,
  props<{ staffGroupId: number }>()
);

export const StaffGroupAuditLoadError = createAction(
  CompanyProfileActionTypes.StaffGroupAuditLoadError,
  props<{ err: any }>()
);

export const StaffGroupAuditLoaded = createAction(
  CompanyProfileActionTypes.StaffGroupAuditLoaded,
  props<{ staffGroupId: number; audits: PagedStaffGroupAudit }>()
);

// duty time allowance
export const LoadDutyTimeAllowanceAudit = createAction(
  CompanyProfileActionTypes.LoadDutyTimeAllowanceAudit,
  props<{
    dutyTimeAllowanceId: number;
    pageNumber: number | null;
    lastAuditLogId: number | null;
  }>()
);

export const LoadNextPageDutyTimeAllowanceAudit = createAction(
  CompanyProfileActionTypes.LoadNextPageDutyTimeAllowanceAudit,
  props<{ dutyTimeAllowanceId: number }>()
);

export const DutyTimeAllowanceAuditLoadError = createAction(
  CompanyProfileActionTypes.DutyTimeAllowanceAuditLoadError,
  props<{ err: any }>()
);

export const DutyTimeAllowanceAuditLoaded = createAction(
  CompanyProfileActionTypes.DutyTimeAllowanceAuditLoaded,
  props<{ dutyTimeAllowanceId: number; audits: PagedDutyTimeAllowanceAudit }>()
);
